import { Box, Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import RepeatRoundedIcon from "@mui/icons-material/RepeatRounded";
import { AgentShortcuts } from "../../../Shared-ui/Types/common";

interface MyComponentProps {
  agentShortuts: any;
  messageId: number;
  sendMessageShortcuts: (shortcut: string, messageId: number) => void;
  incomingTextColor?: any;
}

const AgentPrompts: React.FC<MyComponentProps> = (props) => {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMoreClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleRewriteClick = (option: string) => {
    props.sendMessageShortcuts(option, props.messageId);
    // const currentMessage =
    //   messages[messages.length - 1]?.agentData?.response?.replace(
    //     /<[^>]*>/g,
    //     ""
    //   ) || "";
    // const prompt = `${option} this: ${currentMessage}`;
    // setUserInput(prompt);
    // handleMenuClose();
    // inputRef.current?.focus();
  };

  const test = (value: string) => {
    setActiveCategory(value);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveCategory(null);
  };

  return (
    <>
      <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
        <Button
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleMoreClick(e);
          }}
          startIcon={
            <Box
              sx={{
                transform: "scaleX(-1)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <RepeatRoundedIcon fontSize="small" />
            </Box>
          }
          endIcon={<KeyboardArrowDownIcon />}
          sx={{
            minWidth: "auto",
            px: 2,
            py: 0.5,
            height: "32px",
            //border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: "16px",
            textTransform: "none",
            color: props.incomingTextColor,
            fontSize: "0.875rem",
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            "&:hover": {
              color: "#02BEDB",
            },
          }}
        >
          Rewrite
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right", // Align to button's right
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right", // Menu appears aligned to right
          }}
          sx={{
            "& .MuiPaper-root": {
              width: "auto", // Increased width to accommodate submenu
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              borderRadius: "12px",
              mt: .5,
              display: "flex",
              overflow: "visible",
            },
          }}
        >
          <Box
            sx={{
              width: "240px",
            }}
          >
            {props.agentShortuts?.categories &&
              props.agentShortuts?.categories?.map((category: string) => (
                <Box key={category}>
                  <MenuItem
                    //onMouseEnter={() => test(category)}
                    onClick={() => setActiveCategory(activeCategory === category ? null : category)}
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 500,
                      color: "text.secondary",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor:
                        activeCategory === category
                          ? "rgba(0,0,0,0.04)"
                          : "transparent",
                      "&:hover": {
                        backgroundColor: "rgba(0,0,0,0.04)",
                      },
                    }}
                  >
                    {category}
                    <KeyboardArrowRightIcon sx={{ fontSize: 20 }} />
                  </MenuItem>
                  {activeCategory === category && (
                    <Box sx={{ }}>
                      {props.agentShortuts.category_structure[
                        category as keyof typeof props.agentShortuts.category_structure
                      ]?.map((item: any) => (
                        <MenuItem
                          key={item.action}
                          onClick={() => {
                            handleRewriteClick(item.action);
                            handleMenuClose();
                          }}
                          sx={{
                            fontSize: "0.875rem",
                            pl: 4,
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Box>
                  )}
                </Box>
              ))}
          </Box>
        </Menu>
      </Box>
    </>
  );
};

export default AgentPrompts;
